const BUSINESS_ZONE = "Australia/Sydney";

/** Today as YYYY-MM-DD on the Sydney calendar, the same day the server checks dates against. */
export const businessToday = (now = new Date()) =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone: BUSINESS_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now);
